<template>
    <div class="stretch-layout">
        <card xs-tile sm-tile class="flex-grow-1">
			<participation-table :lists="lists" :event="eventStore.event" v-model:filter="filter" class="py-16 md:py-20"/>
		</card>
    </div>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$api, $web, $date} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
const page = eventStore.getPage(EventPageType.Participations);
if (!page) {
	await navigateTo(eventStore.hasActivePage(EventPageType.Results) ? $web('events.results.index', eventStore.event._key) : $web('events.show', eventStore.event._key));
}

const {data: lists} = await useApiFetch($api('events.participation_lists.index', eventStore.event.id), {
	guest: true,
	params: {
		ts: eventStore.event.cache_buster,
		relations: ['columns.input'],
		public: true
	}
});

const filter = ref({
	list: route.query.list ? route.query.list : (lists.length ? lists[0]._key : undefined),
	search: route.query.search
});

const selectedList = computed(() => {
	return filter.value.list ? lists.find(list => list._key === filter.value.list) : null
});

useMeta({
	title: eventStore.buildPageTitle(t('view.events.participations.index.title', {event: eventStore.event.display_name, list: selectedList.value ? selectedList.value.name : ''})),
	description: selectedList.value && selectedList.value.description ? selectedList.value.description : t('view.events.participations.index.description', {event: eventStore.event.display_name})
})

</script>

